import { Link } from "react-router-dom";

// Official NewsLayer.com logo (assets in /public)
export const Logo = ({ to = "/", compact = false }: { to?: string; compact?: boolean }) => (
  <Link to={to} className="flex items-center group shrink-0" data-testid="newslayer-logo">
    <img
      src={compact ? "/logo-icon.png" : "/logo.png"}
      alt="NewsLayer.com"
      className={`${compact ? "h-9" : "h-[42px] sm:h-12 lg:h-[52px]"} w-auto max-w-none shrink-0 transition-transform duration-200 group-hover:-translate-y-0.5`}
    />
  </Link>
);
